import React, { useState, useEffect } from "react";
import YouTube from "react-youtube";

const AdminLectureComp = ({ lecture, onClose }) => {
  const [videoLink] = useState(lecture.videoLink);
  const getVideoId = (url) => {
    const regex =
      /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"\'&?\/\s]{11})/;
    const match = url.match(regex);
    return match ? match[1] : null;
  };

  const videoId = getVideoId(videoLink);
  const [dimensions, setDimensions] = useState({ width: 400, height: 225 });
  const [position, setPosition] = useState({ x: 850, y: 300 }); // Position of the modal

  const calculateDimensions = () => {
    const width = Math.min(window.innerWidth * 0.9, 400);
    const height = (width / 16) * 9;
    setDimensions({ width, height });
  };

  useEffect(() => {
    calculateDimensions();
    window.addEventListener("resize", calculateDimensions);
    return () => {
      window.removeEventListener("resize", calculateDimensions);
    };
  }, []);

  useEffect(() => {
    setPosition({ x: position.x, y: position.y });
  }, [lecture]);

  const handleMouseDown = (e) => {
    const startX = e.clientX - position.x;
    const startY = e.clientY - position.y;

    const handleMouseMove = (e) => {
      const newX = e.clientX - startX;
      const newY = e.clientY - startY;
      setPosition({ x: newX, y: newY });
    };

    const handleMouseUp = () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
    };

    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("mouseup", handleMouseUp);
  };

  return (
    <div
      className="relative bg-white shadow-lg rounded-lg overflow-hidden"
      style={{
        width: `${dimensions.width}px`,
        height: `${dimensions.height + 40}px`,
        top: `${position.y}px`,
        left: `${position.x}px`,
        position: "absolute", // Allow moving the modal
        cursor: "move", // Show move cursor when hovering the modal
        zIndex: "10000",
      }}
      onMouseDown={handleMouseDown} // Initiate drag on mouse down
    >
      {/* Close Button */}
      <button
        onClick={onClose}
        className="absolute top-2 right-2 p-2 bg-red-500 text-white rounded-full hover:bg-red-600"
      >
        X
      </button>

      {/* YouTube Video */}
      <div className="flex-grow flex items-center justify-center">
        <YouTube
          className="w-full h-full"
          videoId={videoId}
          opts={{
            width: `${dimensions.width}px`,
            height: `${dimensions.height}px`,
            playerVars: {
              rel: 0,
              controls: 1,
              modestbranding: 1,
              fs: 0,
              cc_load_policy: 0,
              iv_load_policy: 3,
            },
          }}
        />
      </div>
    </div>
  );
};

export default AdminLectureComp;
